let pendingPreview

export function rememberPhotoPreview(image, path) {
  pendingPreview = image?.complete && image.naturalWidth > 0 ? {
    path,
    photoId: image.dataset.photoId,
    src: image.currentSrc
  } : null
}

document.addEventListener("turbo:before-render", ({ detail: { newBody } }) => {
  const pending = pendingPreview
  if (!document.documentElement.hasAttribute("data-turbo-preview")) pendingPreview = null
  if (!pending) return

  const gallery = newBody.querySelector('[data-controller~="gallery"]')
  const image = gallery?.querySelector('[data-gallery-target="image"]')
  if (!image || gallery.dataset.galleryListingPath !== pending.path || image.dataset.photoId !== pending.photoId) return

  gallery.querySelectorAll("[data-gallery-preview]").forEach(preview => preview.remove())
  const preview = document.createElement("img")
  preview.src = pending.src
  preview.alt = ""
  preview.setAttribute("aria-hidden", "true")
  preview.dataset.galleryPreview = ""
  preview.className = "absolute inset-0 h-full w-full object-cover"
  image.parentElement.append(preview)
})
